<template>
  <div>
  <el-container>

      <el-container>
        <el-aside width="200px">
          <div class="main-nav">
            <a href="#/dashboard"><img  class="dashboard-logo" src="../../assets/logo.png"></a>
            <ul>
              <li > <router-link to="/dashboard/"><i class="fas fa-list-alt"></i>Dashboard</router-link> </li>
              <!-- <li><router-link to="/dashboard/progress"><i class="fas fa-chart-bar"></i>Progress</router-link></li> -->
              <li><router-link to="/dashboard/content"><i class="fas fa-bookmark"></i>Content</router-link></li>
              <!-- <li><router-link to="/dashboard/addons"><i class="fas fa-plus-circle"></i>Add-Ons</router-link></li> -->
              <li>
                <a href="http://www.facebook.com/groups/wzatc19" target="_blank">
                  <i class="fas fa-external-link-alt"></i>Facebook Group</a>
              </li>
              <!-- <li>
                <a href="https://transformation.wodapalooza.com/app/#/dashboard/content/article/Kj5S3EiYpw" target="_blank">
                  <i class="fas fa-external-link-alt"></i>RP eBook</a>
              </li> -->
              <!-- <li>
                <a href="https://gum.co/NOGoq" target="_blank">
                  <i class="fas fa-external-link-alt"></i>RP eBook (Spanish)</a>
              </li> -->
              <li>
                <span class="menu-title">Workout Programs</span>
              </li>
              <li class="workout-link">
                 <router-link to="/dashboard/content/article/iAFMP3CInY">WZA At Home</router-link>
              </li>
              <li  class="workout-link">

                  <router-link to="/dashboard/content/article/laeHX0CzOJ">WZA Beach Body</router-link>
              </li>
              <li  class="workout-link">
                  <router-link to="/dashboard/content/article/p3cniOKJxZ">WZA-Fit</router-link>
              </li>
              <li  class="workout-link">
                  <router-link to="/dashboard/content/article/VuwqpaHgS3">Weekly ROMWOD</router-link>
              </li>
              <li class="settings-menu">
                <router-link to="/dashboard/settings"><i class="fas fa-cog"></i>Settings</router-link></li>
              <li class="settings-menu">
                <router-link to="/dashboard/my-details"><i class="fas fa-cog"></i>My Details</router-link></li>
            </ul>
            <el-button @click="logOut" class="logout-btn" size="mini" type="text">Log Out</el-button>
          </div>
        </el-aside>
        <el-main>
          <el-header>
            <h3 class="sponsor-title">WEEK {{week}}, Presented by </h3>
            <a v-if="this.sponsor" :href="sponsor.weeklySponsorUrl" target="_blank"><img class="sponsor-image" v-bind:src="this.sponsor.weeklySponsorImage" /></a>
            <div class="day-section">
                <h4>DASHBOARD</h4>
                <h5>DAY {{day}}</h5>
                <!-- <h5>Pre-Challenge</h5> -->
            </div>
          </el-header>
          <div class="content-wrapper">
            <router-view />
          </div>
          <div class="adds-container">
            <h4>PARTNERS</h4>
            <template v-if="sponsor">
            <div v-for="(partner, index) in ['partnerOne', 'partnerTwo','partnerThree', 'partnerFour', 'partnerFive', 'partnerSix', 'partnerSeven', 'partnerEight', 'partnerNine', 'partnerTen']" class="add-box" :key="index">
              <template v-if="sponsor[`${partner}Image`]">
                <a :href="sponsor[`${partner}Link`]" target="_bank">
                  <img :src="sponsor[`${partner}Image`]">
                </a>
                <span v-show="sponsor[`${partner}Promo`]">{{sponsor[`${partner}Promo`]}}</span>
              </template>
            </div>
            </template>
          </div>
          <el-footer>© The Wodapalooza, LLC - <a target="_blank" href="https://transformation.wodapalooza.com/app/#/dashboard/terms">Terms of Use</a></el-footer>
        </el-main>

      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment';
export default {
  name: 'dashboard',
  computed: mapGetters({
    welcomeMessage: 'welcomeMessage',
    weeklySponsorImage: 'weeklySponsorImage',
    weeklySponsorLink: 'weeklySponsorLink',
    partners: 'partners',
  }),

  mounted() {
    var a = moment('2019-04-29');
    var b = moment();
    this.day = b.diff(a, 'days') + 1;
    this.week = Math.ceil(this.day / 7);
    var settingsQuery = new Parse.Query('Settings');
    settingsQuery.equalTo('week', this.week);
    settingsQuery.first().then(res => {
      this.sponsor= res.attributes;
      this.$store.commit('setWelcomeMessage', res.attributes.welcomeMessage);
    })
  },

  data () {
    return {
      day: 1,
      week:1,
      msg: 'This is the forgot',
      sponsor: null,
    }
  },
  methods: {
    logOut:function(){
      var _this = this;
      Parse.User.logOut()
        .then(function(){
          _this.$router.push('/login');
        })
        .catch(function(err){
          console.log(err);
        });
    }
  }
}
</script>

<style>
.main-nav {
  background-color: #002146;
  width: 200px;
  height: 100%;
  position: fixed;
  border-top: 5px solid #D70073;
  left: 0;
}
.content-wrapper {
  padding: 30px 220px 20px 30px;
  max-width: 800px;
  margin: 0 auto;
}
.adds-container{
  width: 150px;
  padding: 80px 20px 30px;
  position: absolute;
  right: 0;
  top: 0;
  height: auto;
  background-color: #E0E0E0;
}
.el-footer {
  font-size:14px;
}
.el-footer a{
  text-decoration:none;
  color:#409EFF;
}
.adds-container h4 {
  color: #666;
  margin: 0 auto 10px;
}
.el-main {
  padding: 0;
  background-color: #EEEEEE;
}
.el-header {
  background-color: #FFF;
  z-index: 100;
  position: relative;
}
.dashboard-logo{
  width: 100px;
  margin: 10px auto;
}
.main-nav ul {
  list-style: none;
  padding-left: 20px;
}
.main-nav ul li{
  text-align: left;
  color: #9BA1AC;
  line-height: 32px;
  font-weight: normal;
  font-size: 12px;
}
.main-nav ul li a {
  color: #9BA1AC;
  text-decoration: none;
}
.main-nav ul li i {
  margin-right: 10px;
}

.sponsor-title {
  font-family: "prohibition";
  color: #666;
  margin: 0 10px 0;
  font-size: 18px;
  text-align: left;
  line-height: 60px;
  float: left;
}
.sponsor-image {
  float: left;
  width: 150px;
  margin-top: 10px;
}
.day-section{
  font-family: "prohibition";
  color: #666;
  width: 30%;
  float: right;
  margin: 0;
}
.day-section h4 {
  margin: 5px 0 0;
  text-align: right;

}
.day-section h5{
  font-family: "prohibition";
  color: #666;
  text-align: right;
  line-height: 22px;
  margin: 0;
  font-size: 22px;
  color: #D70073;
}
.add-box {
  margin-bottom: 20px;
}
.add-box img {
  width: 100%;
}
.el-row {
  margin-bottom: 30px!important;
}
.logout-btn {
  position: fixed;
  bottom:10px;
  left: 0;
  width: 200px;
}
.menu-title {
  color:#FFF;
}
.workout-link {
  padding-left:10px;
}

</style>
